import { SVGComponentPropsType } from './types';

const defaultSize = 20;

export default ({ size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    width={size}
    height={size}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <path
      d="M20 10L0 20l3-10L0 0l20 10zm-4.471 0L3.246 3.858 4.789 9H10v2H4.789l-1.543 5.141L15.529 10z"
      fillRule="nonzero"
    />
  </svg>
);
